
import objectAssign from 'object-assign'
import mentionsMixin from './mentions-mixin'
import SirTrevor from "sir-trevor";

export default (function(){

  return SirTrevor.Block.extend(objectAssign({}, mentionsMixin, {

    type: 'table',
    title: function() { return 'table'; },

    controllable: true,
    multi_editable: true,

    tableHTML: `
      <div class="st-table">
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    `,

    controls: {
      'addrow': function(e) {
        this.addRowHandler(e);
      },
      'delrow': function(e) {
        this.deleteRowHandler(e);
      },
      'addcol': function(e) {
        this.addColumnHandler(e);
      },
      'delcol': function(e) {
        this.deleteColumnHandler(e);
      }
    },

    scribeOptions: {
      tags: {
        p: true,
        a: true,
        span: true,
        b: true,
        input: true
      }
    },

    icon_name: 'table',

    editorHTML: function() {
      return this.tableHTML;
    },

    addEditorToCell: function(el) {
      let text = this.insertMentions(el.innerHTML);
      let editor = this.newTextEditor('<div class="st-block__editor" style="width: 100%; height: 100%;"></div>', text);
      el.innerHTML = '';
      el.appendChild(editor.node);
      editor.el.addEventListener('keypress', this.detectMentionStart.bind(this));
      editor.el.addEventListener('keyup', this.findMentions.bind(this));
      editor.el.addEventListener('keydown', (e) => {
        this.onMentionKeyDown(e);
      });
    },

    onBlockRender: function() {
      this.initializeMentions();

      this.table = this.inner.querySelector('table');
      this.tableHead = this.table.querySelector('thead');
      this.tableBody = this.table.querySelector('tbody');
      Array.from(this.table.querySelectorAll('th'), el => {
        this.addEditorToCell(el);
      });
      Array.from(this.table.querySelectorAll('td'), el => {
        this.addEditorToCell(el);
      });
    },

    loadData: function(data) {
      this.inner.querySelector('.st-table').innerHTML = data.table;
    },

    _serializeData: function() {
      if (this.table === undefined) { return {}; }

      const getTableHeadHTML = () => {
        let html = '';
        if (this.tableHead) {
          html += '<thead>';
          Array.from(this.tableHead.querySelectorAll('tr'), row => {
            html += '<tr>';
            Array.from(row.querySelectorAll('th'), cell => {
              html += `<th>${this.getCellContent(cell)}</th>`;
            });
            html += '</tr>';
          });
          html += '</thead>';
        }
        return html;
      }

      const getTableBodyHTML = () => {
        let html = '';
        Array.from(this.tableBody.querySelectorAll('tr'), row => {
          html += '<tr>';
          Array.from(row.querySelectorAll('td'), cell => {
            html += `<td>${this.getCellContent(cell)}</td>`;
          });
          html += '</tr>';
        });
        return html;
      }

      let tableHTML = `
        <table>
          ${getTableHeadHTML()}
          <tbody>
            ${getTableBodyHTML()}
          </tbody>
        </table>
      `;

      return {
        table: tableHTML,
        format: 'html'
      };
    },

    isEmpty: function() {
      return false;
    },

    getCellContent(cell) {
      let textEditor = this.getTextEditor(cell.querySelector('div').getAttribute('data-editorId'));
      return this.getTextContentWithMentions(textEditor.scribe.getContent());
    },

    addCell: function(row, tagName) {
      tagName = tagName || row.children[0].tagName.toLowerCase();

      let tagNode = document.createElement(tagName);
      this.addEditorToCell(tagNode);
      row.appendChild(tagNode);
    },

    addRowHandler: function(e) {
      e.preventDefault();

      let row = document.createElement('tr');
      Array.from(this.table.querySelector('tr').querySelectorAll('td, th'), () => {
        this.addCell(row, "td");
      });
      this.tableBody.appendChild(row);
    },

    addColumnHandler: function(e) {
      e.preventDefault();

      Array.from(this.table.querySelectorAll('tr'), el => {
        this.addCell(el);
      });
    },

    deleteColumnHandler: function(e) {
      e.preventDefault();

      Array.from(this.table.querySelectorAll('tr'), el => {
        if (el.children.length > 1) {
          el.removeChild(el.lastChild);
        }
      });
    },

    deleteRowHandler: function(e) {
      e.preventDefault();

      if (this.getTableRows().length > 1) {
        this.tableBody.lastChild.parentNode.removeChild(this.tableBody.lastChild);
      }
    },

    getTableRows: function() {
      return Array.from(this.tableBody.querySelectorAll('tr'));
    }
  }));
})();
